import { useContext, useEffect } from "react"
import { NotificationPageItem } from "../../components/notifications/NotificationsPageItem"
import { NotificationCtx } from "../../context/notificationContext"
import moment from "moment"

export default function Notifications() {
  const { notifications, getNotifications } = useContext(NotificationCtx)

  useEffect(() => {
    getNotifications()
  }, [])

  const sortedNotifications = notifications.sort(
    (a, b) =>
      moment.utc(b.created_at).toDate().getTime() -
      moment.utc(a.created_at).toDate().getTime()
  )

  return (
    <div className="container max-w-screen-md pb-12">
      <h1 className="font-bold text-2xl sm:text-4xl mb-4">
        Notifications
      </h1>
      <div className="w-full h-px bg-border mb-12"></div>
      {notifications.length > 0 ? (
        <>
          {sortedNotifications.map((n) => {
            return (
              <NotificationPageItem
                key={n.id}
                notification={n}
              />
            )
          })}
        </>
      ) : (
        <h3 className="font-bold text-muted-foreground">
          You do not currently have any notifications. Check back later!
        </h3>
      )}
    </div>
  )
}